import { completeName, uppercaseInitials } from '../../utils';

export const normalizeDataProfessional = (payload: any) => {
  const data = payload?.item;
  return data ? {
    ...data,
    name: completeName(data.firstName, data.middleName, data.lastName),
    initialsName: uppercaseInitials(data.firstName, data.middleName, data.lastName),
  } : null;
};
